import { z } from 'zod';

import {
  createdByServiceUuid,
  nullableCreatedByUserUuid,
  timestamps,
  uuid,
} from '../common';
import {
  alphaQuoteEvaluationStatusSchema,
  alphaQuoteLineStatusSchema,
  alphaQuoteSyncStatusSchema,
} from '../enums';

export const base = {
  uuid,
  status: alphaQuoteLineStatusSchema,
  evaluationStatus: alphaQuoteEvaluationStatusSchema,
  syncStatus: alphaQuoteSyncStatusSchema,

  lastAppliedAt: z.date().nullish(),
  lastApplyFailedAt: z.date().nullish(),

  alphaQuoteUuid: uuid,
  alphaQuoteLineImportUuid: uuid.nullish(),
  snapQuoteLineUuid: uuid.nullish(),

  ...timestamps,
  ...nullableCreatedByUserUuid,
  ...createdByServiceUuid,
};

export const alphaQuoteLineBaseSchema = z.object(base);

export type AlphaQuoteLineBase = z.output<typeof alphaQuoteLineBaseSchema>;
